/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14Inputs */

const en_yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14 = /** @type {(inputs: Yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your password has been reset successfully. You will be redirected to the login page shortly.`)
};

const de_yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14 = /** @type {(inputs: Yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Passwort wurde zurückgesetzt. Du wirst gleich zur Anmeldung weitergeleitet.`)
};

/**
* | output |
* | --- |
* | "Your password has been reset successfully. You will be redirected to the login page shortly." |
*
* @param {Yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14 = /** @type {((inputs?: Yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14(inputs)
	return de_yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14(inputs)
});
export { yourpasswordhasbeenresetsuccessfullyyouwillberedirectedtotheloginpageshortly14 as "yourPasswordHasBeenResetSuccessfullyYouWillBeRedirectedToTheLoginPageShortly" }